import React from "react";

const WhatWeBelive = () => {
    return (
        <section className="what_we_believe">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="heading">
                            <h2>Our Philosophy</h2>
                            <p>We are a bespoke digital product development studio specializing in mobile apps, AI agents, workflow automations, and web applications.
                            Our approach is simple — custom-built, AI-powered solutions delivered with full responsibility and zero excuses.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhatWeBelive;
